/*
 * YAMIWARD — THE WALLPAPER VAULT (壁紙保管庫)
 * Codex wallpapers + Twelve Bloodlines clan wallpapers, drawn on canvas from
 * text/kanji only (never taints). Previews are free; downloads unlock for registered residents
 * (Ward list — same yw_resident_registered flag as the Resident Permit).
 * Night Parade visitors get the night-palette variant automatically.
 */
(function () {
    'use strict';

    var REG_KEY = 'yw_resident_registered';

    var SIZES = [
        { key: 'phone', label: 'PHONE 1170×2532', w: 1170, h: 2532 },
        { key: 'tablet', label: 'TABLET 1536×2048', w: 1536, h: 2048 },
        { key: 'desktop', label: 'DESKTOP 2560×1440', w: 2560, h: 1440 }
    ];

    var selectedSize = SIZES[0];
    var stage = null;

    // Defensive: set the registered flag here too, in case script order changes.
    try {
        if (window.location.search.indexOf('customer_posted=true') !== -1) {
            localStorage.setItem(REG_KEY, '1');
        }
    } catch (e) { /* ignore */ }

    function isRegistered() {
        try { return localStorage.getItem(REG_KEY) === '1'; } catch (e) { return false; }
    }

    function el(tag, cls, text) {
        var node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text !== undefined) node.textContent = text;
        return node;
    }

    function pad(n) { return (n < 10 ? '00' : '0') + n; }

    function hash(str) {
        var h = 5381;
        for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
        return h;
    }

    /* ---------- Wallpaper renderer ---------- */

    function drawWallpaper(entry, W, H, night) {
        var f = window.YW_CODEX.factions[entry.faction];
        var seed = hash(entry.name);
        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');
        var S = Math.min(W, H) / 1080; // scale unit
        var portrait = H >= W;

        // Base
        ctx.fillStyle = night ? '#03030A' : '#060609';
        ctx.fillRect(0, 0, W, H);

        // Ambient glow (crimson by day, violet by night) + faction wash
        var g1 = ctx.createRadialGradient(W * 0.85, H * 0.1, 10, W * 0.85, H * 0.1, Math.max(W, H) * 0.7);
        g1.addColorStop(0, night ? 'rgba(109,90,230,0.14)' : 'rgba(229,30,37,0.10)');
        g1.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g1;
        ctx.fillRect(0, 0, W, H);
        var g2 = ctx.createRadialGradient(W * 0.15, H * 0.9, 10, W * 0.15, H * 0.9, Math.max(W, H) * 0.6);
        g2.addColorStop(0, hexAlpha(f.color, 0.08));
        g2.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g2;
        ctx.fillRect(0, 0, W, H);

        // Scanline texture
        ctx.fillStyle = 'rgba(255,255,255,0.012)';
        for (var y = 0; y < H; y += Math.max(4, Math.round(6 * S))) {
            ctx.fillRect(0, y, W, 1);
        }

        // Faction edge rail
        ctx.fillStyle = hexAlpha(f.color, 0.55);
        ctx.fillRect(0, 0, Math.max(3, 6 * S), H);
        ctx.fillStyle = hexAlpha(f.color, 0.18);
        ctx.fillRect(Math.max(3, 6 * S), 0, Math.max(2, 3 * S), H);

        // Giant kanji — outline pass + low fill, slight deterministic offset
        var kanji = entry.kanji.slice(0, 1);
        var kSize = (portrait ? W : H) * (0.82 + (seed % 9) / 100);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var kx = W / 2 + ((seed % 60) - 30) * S;
        var ky = H * (portrait ? 0.42 : 0.5);
        ctx.font = '900 ' + Math.round(kSize) + 'px "Noto Sans JP", sans-serif';
        ctx.strokeStyle = hexAlpha(f.color, 0.5);
        ctx.lineWidth = Math.max(1, 2 * S);
        ctx.strokeText(kanji, kx, ky);
        ctx.fillStyle = hexAlpha(f.color, 0.10);
        ctx.fillText(kanji, kx, ky);

        // Ghost duplicate offset (RGB-split feel)
        ctx.strokeStyle = night ? 'rgba(183,167,240,0.22)' : 'rgba(229,30,37,0.18)';
        ctx.strokeText(kanji, kx + 7 * S, ky + 5 * S);

        // Header
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = 'rgba(243,243,245,0.75)';
        ctx.font = '700 ' + Math.round(26 * S) + 'px "Space Mono", monospace';
        ctx.fillText('YAMIWARD', 60 * S, 90 * S);
        ctx.fillStyle = hexAlpha(f.color, 0.9);
        ctx.font = '700 ' + Math.round(20 * S) + 'px "Space Mono", monospace';
        ctx.fillText('CODEX ENTRY ' + pad(entry.n), 60 * S, 130 * S);
        if (night) {
            ctx.fillStyle = 'rgba(183,167,240,0.8)';
            ctx.fillText('百鬼夜行 — NIGHT ISSUE', 60 * S, 170 * S);
        }

        // Entity block (bottom)
        var by = H - 220 * S;
        ctx.fillStyle = '#F3F3F5';
        var nameSize = Math.round(56 * S);
        ctx.font = '900 ' + nameSize + 'px Outfit, sans-serif';
        while (ctx.measureText(entry.name).width > W - 120 * S && nameSize > 22 * S) {
            nameSize = Math.round(nameSize * 0.92);
            ctx.font = '900 ' + nameSize + 'px Outfit, sans-serif';
        }
        ctx.fillText(entry.name, 60 * S, by);
        ctx.fillStyle = hexAlpha(f.color, 0.95);
        ctx.font = '900 ' + Math.round(30 * S) + 'px "Noto Sans JP", sans-serif';
        ctx.fillText(entry.kanji, 60 * S, by + 44 * S);
        ctx.fillStyle = 'rgba(243,243,245,0.55)';
        ctx.font = '400 ' + Math.round(19 * S) + 'px "Space Mono", monospace';
        ctx.fillText(f.label + '  ·  ' + entry.cls, 60 * S, by + 84 * S);

        // Barcode footer (deterministic)
        var bx = 60 * S, bby = H - 90 * S;
        ctx.fillStyle = 'rgba(243,243,245,0.5)';
        for (var i = 0; i < 40; i++) {
            var wb = ((seed >> (i % 28)) & 1) ? 4 * S : 1.6 * S;
            ctx.fillRect(bx, bby, wb, 34 * S);
            bx += wb + 3.4 * S;
        }

        return canvas;
    }

    /* ---------- Bloodline wallpaper renderer (Twelve Bloodlines) ---------- */

    function drawClanWallpaper(clan, W, H, night) {
        var months = window.YW_CLANS.months;
        var seed = hash(clan.name);
        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');
        var S = Math.min(W, H) / 1080;
        var portrait = H >= W;

        // Base
        ctx.fillStyle = night ? '#03030A' : '#060609';
        ctx.fillRect(0, 0, W, H);

        // Ambient glow — clan color by day, violet wash by night
        var g1 = ctx.createRadialGradient(W * 0.85, H * 0.1, 10, W * 0.85, H * 0.1, Math.max(W, H) * 0.7);
        g1.addColorStop(0, night ? 'rgba(109,90,230,0.14)' : hexAlpha(clan.color, 0.10));
        g1.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g1;
        ctx.fillRect(0, 0, W, H);
        var g2 = ctx.createRadialGradient(W * 0.15, H * 0.9, 10, W * 0.15, H * 0.9, Math.max(W, H) * 0.6);
        g2.addColorStop(0, hexAlpha(clan.color, 0.08));
        g2.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g2;
        ctx.fillRect(0, 0, W, H);

        // Scanline texture
        ctx.fillStyle = 'rgba(255,255,255,0.012)';
        for (var y = 0; y < H; y += Math.max(4, Math.round(6 * S))) {
            ctx.fillRect(0, y, W, 1);
        }

        // Clan edge rail
        ctx.fillStyle = hexAlpha(clan.color, 0.55);
        ctx.fillRect(0, 0, Math.max(3, 6 * S), H);
        ctx.fillStyle = hexAlpha(clan.color, 0.18);
        ctx.fillRect(Math.max(3, 6 * S), 0, Math.max(2, 3 * S), H);

        // Giant kanji watermark — full clan kanji, shrunk to fit
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var kSize = (portrait ? W : H) * 1.0;
        ctx.font = '900 ' + Math.round(kSize) + 'px "Noto Sans JP", sans-serif';
        while (ctx.measureText(clan.kanji).width > W * 0.95 && kSize > 60) {
            kSize *= 0.92;
            ctx.font = '900 ' + Math.round(kSize) + 'px "Noto Sans JP", sans-serif';
        }
        var kx = W / 2 + ((seed % 60) - 30) * S;
        var ky = H * (portrait ? 0.40 : 0.46);
        ctx.strokeStyle = hexAlpha(clan.color, 0.4);
        ctx.lineWidth = Math.max(1, 2 * S);
        ctx.strokeText(clan.kanji, kx, ky);
        ctx.fillStyle = hexAlpha(clan.color, 0.08);
        ctx.fillText(clan.kanji, kx, ky);
        ctx.strokeStyle = night ? 'rgba(183,167,240,0.20)' : hexAlpha(clan.color, 0.16);
        ctx.strokeText(clan.kanji, kx + 7 * S, ky + 5 * S);

        // Registry seal — rings, 12 month ticks (birth month lit), kanji core
        var R = (portrait ? W : H) * 0.21;
        var cx = W / 2, cy = ky;
        ctx.strokeStyle = clan.color;
        ctx.lineWidth = Math.max(2, 5 * S);
        ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.stroke();
        ctx.lineWidth = Math.max(1, 1.6 * S);
        ctx.beginPath(); ctx.arc(cx, cy, R - 14 * S, 0, Math.PI * 2); ctx.stroke();
        for (var i = 0; i < 12; i++) {
            var ang = (i / 12) * Math.PI * 2 - Math.PI / 2;
            var active = (i === clan.month - 1);
            var r1 = R + 10 * S, r2 = R + (active ? 30 : 21) * S;
            ctx.strokeStyle = active ? clan.color : 'rgba(243,243,245,0.28)';
            ctx.lineWidth = active ? Math.max(3, 6 * S) : Math.max(1, 2.4 * S);
            ctx.beginPath();
            ctx.moveTo(cx + Math.cos(ang) * r1, cy + Math.sin(ang) * r1);
            ctx.lineTo(cx + Math.cos(ang) * r2, cy + Math.sin(ang) * r2);
            ctx.stroke();
        }
        ctx.fillStyle = clan.color;
        var coreSize = R * 0.82;
        ctx.font = '900 ' + Math.round(coreSize) + 'px "Noto Sans JP", sans-serif';
        while (ctx.measureText(clan.kanji).width > R * 1.5 && coreSize > 20) {
            coreSize *= 0.9;
            ctx.font = '900 ' + Math.round(coreSize) + 'px "Noto Sans JP", sans-serif';
        }
        ctx.fillText(clan.kanji, cx, cy + R * 0.03);

        // Header
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = 'rgba(243,243,245,0.75)';
        ctx.font = '700 ' + Math.round(26 * S) + 'px "Space Mono", monospace';
        ctx.fillText('YAMIWARD', 60 * S, 90 * S);
        ctx.fillStyle = hexAlpha(clan.color, 0.9);
        ctx.font = '700 ' + Math.round(20 * S) + 'px "Space Mono", monospace';
        ctx.fillText('THE TWELVE BLOODLINES · 血統登録', 60 * S, 130 * S);
        if (night) {
            ctx.fillStyle = 'rgba(183,167,240,0.8)';
            ctx.fillText('百鬼夜行 — NIGHT ISSUE', 60 * S, 170 * S);
        }

        // Clan block (bottom)
        var by = H - 250 * S;
        ctx.fillStyle = '#F3F3F5';
        var nameSize = Math.round(56 * S);
        ctx.font = '900 ' + nameSize + 'px Outfit, sans-serif';
        while (ctx.measureText(clan.name).width > W - 120 * S && nameSize > 22 * S) {
            nameSize = Math.round(nameSize * 0.92);
            ctx.font = '900 ' + nameSize + 'px Outfit, sans-serif';
        }
        ctx.fillText(clan.name, 60 * S, by);
        ctx.fillStyle = hexAlpha(clan.color, 0.95);
        ctx.font = '700 ' + Math.round(22 * S) + 'px "Space Mono", monospace';
        ctx.fillText('THE ' + months[clan.month - 1] + ' BLOODLINE', 60 * S, by + 40 * S);
        ctx.fillStyle = 'rgba(243,243,245,0.6)';
        ctx.font = 'italic 400 ' + Math.round(20 * S) + 'px Outfit, sans-serif';
        var motto = '“' + clan.motto + '”';
        var mSize = Math.round(20 * S);
        while (ctx.measureText(motto).width > W - 120 * S && mSize > 12 * S) {
            mSize = Math.round(mSize * 0.92);
            ctx.font = 'italic 400 ' + mSize + 'px Outfit, sans-serif';
        }
        ctx.fillText(motto, 60 * S, by + 80 * S);

        // Barcode footer (deterministic)
        var bx = 60 * S, bby = H - 90 * S;
        ctx.fillStyle = 'rgba(243,243,245,0.5)';
        for (var j = 0; j < 40; j++) {
            var wb = ((seed >> (j % 28)) & 1) ? 4 * S : 1.6 * S;
            ctx.fillRect(bx, bby, wb, 34 * S);
            bx += wb + 3.4 * S;
        }

        return canvas;
    }

    function hexAlpha(hex, a) {
        var h = hex.replace('#', '');
        var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
        return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    }

    /* ---------- UI ---------- */

    function buildVault() {
        stage.innerHTML = '';
        var registered = isRegistered();
        var night = !!window.YW_NIGHT;

        // Size picker
        var bar = el('div', 'vault-bar');
        bar.appendChild(el('span', 'resident-label', 'FORMAT:'));
        SIZES.forEach(function (s) {
            var b = el('button', 'vault-size-btn' + (s.key === selectedSize.key ? ' active' : ''), s.label);
            b.type = 'button';
            b.addEventListener('click', function () {
                selectedSize = s;
                buildVault();
            });
            bar.appendChild(b);
        });
        stage.appendChild(bar);

        // Gate notice
        var note = el('p', 'vault-note');
        if (registered) {
            note.textContent = 'Residency verified — the vault is open. All formats, all files.' + (night ? ' Night issues active until dawn.' : '');
            note.classList.add('registered');
        } else {
            note.innerHTML = 'Previews are public. Downloads are for registered residents — <a href="#signup">join the Ward list</a>, and the vault opens.';
        }
        stage.appendChild(note);

        // Grid
        var grid = el('div', 'vault-grid');
        var entries = window.YW_CODEX.entries;
        entries.forEach(function (entry) {
            var f = window.YW_CODEX.factions[entry.faction];
            var card = el('div', 'vault-card');
            card.style.setProperty('--vault-accent', f.color);

            // Preview canvas rendered directly at reduced scale
            var scale = 280 / selectedSize.h;
            var preview = drawWallpaper(entry, Math.round(selectedSize.w * scale), Math.round(selectedSize.h * scale), night);
            preview.className = 'vault-preview';
            var pWrap = el('div', 'vault-preview-wrap');
            pWrap.appendChild(preview);
            card.appendChild(pWrap);

            var meta = el('div', 'vault-meta');
            meta.appendChild(el('div', 'vault-card-no', 'ENTRY ' + pad(entry.n)));
            meta.appendChild(el('div', 'vault-card-name', entry.name));
            card.appendChild(meta);

            var btn = el('button', 'btn ' + (registered ? 'btn-primary' : 'btn-secondary') + ' vault-dl-btn');
            btn.type = 'button';
            btn.textContent = registered ? 'DOWNLOAD' : '🔒 RESIDENTS ONLY';
            btn.addEventListener('click', function () {
                if (!isRegistered()) {
                    var signup = document.getElementById('signup');
                    if (signup) signup.scrollIntoView({ behavior: 'smooth' });
                    return;
                }
                var render = function () {
                    var full = drawWallpaper(entry, selectedSize.w, selectedSize.h, !!window.YW_NIGHT);
                    var a = document.createElement('a');
                    a.download = 'yamiward-wallpaper-' + pad(entry.n) + '-'
                        + entry.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')
                        + '-' + selectedSize.key + (window.YW_NIGHT ? '-night' : '') + '.png';
                    a.href = full.toDataURL('image/png');
                    a.click();
                };
                if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
                else render();
            });
            card.appendChild(btn);

            grid.appendChild(card);
        });
        stage.appendChild(grid);

        buildClanShelf(registered, night);
    }

    /* ---------- Bloodline shelf (Twelve Bloodlines wallpapers) ---------- */

    function buildClanShelf(registered, night) {
        if (!window.YW_CLANS || !window.YW_CLANS.list) return;
        var months = window.YW_CLANS.months;
        var myClan = null;
        try { myClan = JSON.parse(localStorage.getItem('yw_clan') || 'null'); } catch (e) { /* ignore */ }

        stage.appendChild(el('div', 'quiz-kicker vault-clan-kicker', 'THE TWELVE BLOODLINES — CLAN WALLPAPERS 血統壁紙'));

        var grid = el('div', 'vault-grid');
        window.YW_CLANS.list.forEach(function (clan) {
            var isMine = !!(myClan && myClan.key === clan.key);
            var card = el('div', 'vault-card' + (isMine ? ' vault-card-is-mine' : ''));
            card.style.setProperty('--vault-accent', clan.color);

            var scale = 280 / selectedSize.h;
            var preview = drawClanWallpaper(clan, Math.round(selectedSize.w * scale), Math.round(selectedSize.h * scale), night);
            preview.className = 'vault-preview';
            var pWrap = el('div', 'vault-preview-wrap');
            pWrap.appendChild(preview);
            card.appendChild(pWrap);

            var meta = el('div', 'vault-meta');
            meta.appendChild(el('div', 'vault-card-no', months[clan.month - 1] + (isMine ? ' · YOUR BLOODLINE' : '')));
            meta.appendChild(el('div', 'vault-card-name', clan.name + ' ' + clan.kanji));
            card.appendChild(meta);

            var btn = el('button', 'btn ' + (registered ? 'btn-primary' : 'btn-secondary') + ' vault-dl-btn');
            btn.type = 'button';
            btn.textContent = registered ? 'DOWNLOAD' : '🔒 RESIDENTS ONLY';
            btn.addEventListener('click', function () {
                if (!isRegistered()) {
                    var signup = document.getElementById('signup');
                    if (signup) signup.scrollIntoView({ behavior: 'smooth' });
                    return;
                }
                var render = function () {
                    var full = drawClanWallpaper(clan, selectedSize.w, selectedSize.h, !!window.YW_NIGHT);
                    var a = document.createElement('a');
                    a.download = 'yamiward-bloodline-' + clan.key + '-' + selectedSize.key + (window.YW_NIGHT ? '-night' : '') + '.png';
                    a.href = full.toDataURL('image/png');
                    a.click();
                };
                if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
                else render();
            });
            card.appendChild(btn);

            grid.appendChild(card);
        });
        stage.appendChild(grid);

        if (!myClan) {
            var note = el('p', 'vault-note');
            note.innerHTML = 'Not yet verified? <a href="#bloodlines">Declare your birth month</a> — one of these twelve is already yours.';
            stage.appendChild(note);
        }
    }

    /* ---------- Init ---------- */

    function init() {
        stage = document.getElementById('vault-stage');
        if (!stage || !window.YW_CODEX) return;
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(buildVault);
        } else {
            buildVault();
        }
        // Redraw previews when night state flips mid-browse.
        document.addEventListener('yw:nightchange', buildVault);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
